import { render, staticRenderFns } from "./depositTable.vue?vue&type=template&id=2137a5ab"
import script from "./depositTable.vue?vue&type=script&lang=js"
export * from "./depositTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports